import { render, staticRenderFns } from "./insect.vue?vue&type=template&id=66808ef4&scoped=true&"
import script from "./insect.vue?vue&type=script&lang=js&"
export * from "./insect.vue?vue&type=script&lang=js&"
import style0 from "./insect.vue?vue&type=style&index=0&id=66808ef4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66808ef4",
  null
  
)

export default component.exports